import BaseStimulusModelController from "../../Features/BaseStimulusModelController";
import { attachSummernote } from '../../scripts/summernoteHelper';
import { selectize } from "../selectizeHelper";
import { DestinationsDetailBasicInformationStimulusModel } from "../_generated/DestinationsDetailBasicInformationStimulusModel";
import { DomEvents } from "../_generated/DomEvents";

export default class DetailBasicInformationController extends BaseStimulusModelController<DestinationsDetailBasicInformationStimulusModel> {
    static targets = [
        "description",
        "searchKeywords",
        "isOfflineDownloadDisabled",
    ];

    readonly descriptionTarget!: HTMLElement;
    readonly searchKeywordsTarget!: HTMLElement;
    readonly isOfflineDownloadDisabledTarget!: HTMLInputElement;

    connect() {
        const descriptionTarget = $(this.descriptionTarget);
        attachSummernote(descriptionTarget);

        selectize($(this.searchKeywordsTarget), {
            plugins: ["remove_button"],
            delimiter: ",",
            persist: false,
            create(input) {
                return {
                    value: input,
                    text: input
                }
            }
        });

        this.dispatch(DomEvents.destinationDetailBasicInformationLoaded);
    }

    disableOfflineDownload() {
        this.isOfflineDownloadDisabledTarget.checked = true;
    }
}